module.exports = __webpack_public_path__ + "static/media/DSC01856.473b8815.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/components/images/gallery/TK_karneval/thumb/DSC01856.jpg
// module id = 482
// module chunks = 0